import React from "react";
import {
  AiOutlineCalendar,
  AiOutlineCar,
  AiOutlineSolution,
  AiOutlineContainer,
  AiOutlineDollarCircle,
  AiOutlineInbox,
  AiOutlineFileText,
  AiOutlineMessage,
  AiOutlineEnvironment,
  AiOutlineMail,
  AiOutlineSmile,
  AiOutlineWhatsApp,
  AiOutlineCompass,
  AiOutlineCoffee,
} from "react-icons/ai";
import { HiOutlineUserGroup } from "react-icons/hi";
import { GoBook } from "react-icons/go";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import axios from "axios";
import { serverUrl } from "../../nestserver";
import { selectSchoolId } from "../../redux/slices/auth.slice";

const TONES = {
  "Connections":          { card: "#dbeafe", circle: "#93c5fd", icon: "#1d4ed8" },
  "Student Attendance":   { card: "#fef9c3", circle: "#fde047", icon: "#a16207" },
  "Day Care Activity":    { card: "#ffe4d5", circle: "#fdba74", icon: "#c2410c" },
  "Progress Card":        { card: "#cffafe", circle: "#67e8f9", icon: "#0e7490" },
  "Homework":             { card: "#e0f2fe", circle: "#7dd3fc", icon: "#0369a1" },

  "Diary":             { card: "#e0f2fe", circle: "#7dd3fc", icon: "#0369a1" },
  "Course Board":         { card: "#fef2f2", circle: "#fecaca", icon: "#b91c1c" },
  "Message":              { card: "#e0f2fe", circle: "#bae6fd", icon: "#0284c7" },
  "Class Announcements":  { card: "#fce7f3", circle: "#f9a8d4", icon: "#be185d" },
  "WhatsApp":             { card: "#dcfce7", circle: "#86efac", icon: "#15803d" },
  "Staff Attendance":     { card: "#f0fdfa", circle: "#99f6e4", icon: "#0f766e" },
  "Transportation":       { card: "#f5f5f4", circle: "#d6d3d1", icon: "#44403c" },
  "Live Bus Tracking":    { card: "#fee2e2", circle: "#fca5a5", icon: "#b91c1c" },
  "Fun":                  { card: "#fdf4ff", circle: "#f5d0fe", icon: "#86198f" },
  "Expenses":             { card: "#fff1f2", circle: "#fecdd3", icon: "#9f1239" },
  "Stock Inventory":      { card: "#f7fee7", circle: "#d9f99d", icon: "#4d7c0f" },
  "Consent Forms":                { card: "#ecfeff", circle: "#a5f3fc", icon: "#0e7490" },
};

const CATEGORIES = [
  { label: "Classroom",     items: ["Connections", "Student Attendance", "Day Care Activity", "Progress Card"] },
  { label: "Academic",      items: ["Course Board", "Homework", "Diary"] },
  { label: "Communication", items: ["Message", "Class Announcements", "WhatsApp"] },
  { label: "Attendance",    items: ["Staff Attendance"] },
  { label: "Finance",       items: ["Expenses"] },
  { label: "Logistics",     items: ["Stock Inventory"] },
  { label: "Transport",     items: ["Transportation", "Live Bus Tracking"] },
  { label: "Learning",      items: ["Fun"] },
  { label: "Consent",       items: ["Consent Forms"] },
];

const InstructorMontessoriMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const schoolId = useSelector(selectSchoolId);

  const school = useQuery(
    ["school", schoolId],
    () => axios.get(`${serverUrl}/school/${schoolId}`, { headers: { Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}` } }).then(r => r.data),
    { enabled: !!schoolId }
  );

  const isTransportationEnabled = school?.data?.result?.data?.is_transportation_enabled !== false;
  const isLiveTrackingEnabled   = school?.data?.result?.data?.is_live_tracking_enabled   !== false;

  const allItems = [
    { title: "Connections",          icon: <HiOutlineUserGroup size={28} />,    onClick: () => navigate("/dashboard/instructor/menu/friends"),              url: "/dashboard/instructor/menu/friends" },
    { title: "Student Attendance",   icon: <AiOutlineCalendar size={28} />,     onClick: () => navigate("/dashboard/instructor/menu/attendance"),           url: "/dashboard/instructor/menu/attendance" },
    { title: "Day Care Activity",     icon: <AiOutlineCoffee size={28} />,       onClick: () => navigate("/dashboard/instructor/menu/daily-activity"),       url: "/dashboard/instructor/menu/daily-activity" },
    { title: "Progress Card",        icon: <AiOutlineFileText size={28} />,     onClick: () => navigate("/dashboard/instructor/menu/montessori-report"),    url: "/dashboard/instructor/menu/montessori-report" },
    { title: "Course Board",         icon: <GoBook size={28} />,                onClick: () => navigate("/dashboard/instructor/menu/course-board"),         url: "/dashboard/instructor/menu/course-board" },
    { title: "Homework",             icon: <AiOutlineContainer size={28} />,    onClick: () => navigate("/dashboard/instructor/menu/message/homework"),     url: "/dashboard/instructor/menu/message/homework" },
    { title: "Diary",             icon: <AiOutlineSolution size={28} />,    onClick: () => navigate("/dashboard/instructor/menu/diary"),     url: "/dashboard/instructor/menu/diary" },
    { title: "Message",              icon: <AiOutlineMessage size={28} />,      onClick: () => navigate("/dashboard/instructor/menu/message"),              url: "/dashboard/instructor/menu/message" },
    { title: "Class Announcements",  icon: <AiOutlineMail size={28} />,         onClick: () => navigate("/dashboard/instructor/menu/class-announcements"), url: "/dashboard/instructor/menu/class-announcements" },
    { title: "WhatsApp",             icon: <AiOutlineWhatsApp size={28} />,     onClick: () => navigate("/dashboard/instructor/menu/whatsapp/groups"),     url: "/dashboard/instructor/menu/whatsapp" },
    { title: "Staff Attendance",     icon: <AiOutlineEnvironment size={28} />,  onClick: () => navigate("/dashboard/instructor/menu/instructor-attendance"),url: "/dashboard/instructor/menu/instructor-attendance" },
    { title: "Transportation",       icon: <AiOutlineCar size={28} />,          onClick: () => navigate("/dashboard/instructor/menu/transportation"),       url: "/dashboard/instructor/menu/transportation" },
    { title: "Live Bus Tracking",    icon: <AiOutlineEnvironment size={28} />,  onClick: () => navigate("/dashboard/instructor/menu/live-tracking"),        url: "/dashboard/instructor/menu/live-tracking" },
    { title: "Fun",                  icon: <AiOutlineSmile size={28} />,        onClick: () => navigate("/dashboard/instructor/menu/fun"),                  url: "/dashboard/instructor/menu/fun" },
    { title: "Expenses",             icon: <AiOutlineDollarCircle size={28} />, onClick: () => navigate("/dashboard/instructor/menu/expenses"),             url: "/dashboard/instructor/menu/expenses" },
    { title: "Stock Inventory",      icon: <AiOutlineInbox size={28} />, onClick: () => navigate("/dashboard/instructor/menu/stock"),                url: "/dashboard/instructor/menu/stock" },
    { title: "Consent Forms",                icon: <AiOutlineCompass size={28} />,      onClick: () => navigate("/dashboard/instructor/menu/consent-form/forms"),           url: "/dashboard/instructor/menu/consent-form" },
  ].filter((item) => {
    if (item.title === "Transportation"  && !isTransportationEnabled) return false;
    if (item.title === "Live Bus Tracking" && !isLiveTrackingEnabled)  return false;
    return true;
  });

  return (
    <div className="p-8">
      <div className="bg-white p-8 rounded-2xl">
        {CATEGORIES.map(({ label, items: titles }) => {
          const catItems = allItems.filter(i => titles.includes(i.title));
          if (!catItems.length) return null;
          return (
            <div key={label} style={{ marginBottom: 32 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14, paddingBottom: 8, borderBottom: "1px solid #f1f5f9" }}>
                {label}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16 }}>
                {catItems.map((item) => {
                  const tone = TONES[item.title] || { card: "#f1f5f9", circle: "#cbd5e1", icon: "#475569" };
                  const isActive = location.pathname.startsWith(item.url);
                  return (
                    <div
                      key={item.title}
                      onClick={item.onClick}
                      style={{
                        background: tone.card,
                        borderRadius: 20,
                        padding: "20px 12px 16px",
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 12,
                        boxShadow: isActive ? `0 0 0 2.5px ${tone.icon}` : "0 2px 8px rgba(0,0,0,0.06)",
                        transition: "all 0.15s ease",
                        minHeight: 120,
                      }}
                      onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.11)"; }}
                      onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = isActive ? `0 0 0 2.5px ${tone.icon}` : "0 2px 8px rgba(0,0,0,0.06)"; }}
                    >
                      <div style={{ width: 58, height: 58, borderRadius: "50%", background: tone.circle, display: "flex", alignItems: "center", justifyContent: "center", color: tone.icon, flexShrink: 0 }}>
                        {item.icon}
                      </div>
                      <div style={{ fontSize: 13, fontWeight: 700, textAlign: "center", lineHeight: 1.35, color: "#1e3a5f" }}>
                        {item.title}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InstructorMontessoriMenu;
